// Formats an organization number for display. Only formats Swedish 10-digit
// numbers as the canonical XXXXXX-XXXX; other formats (Norwegian, Danish,
// Finnish, etc.) are returned as-is so we don't mangle them. Matches the
// pre-existing convention in soliditetMatcher and HandleDuplicates/Helpers.
export const formatOrgNumber = (orgNo: string | number | null | undefined): string => {
	if (!orgNo) {
		return '';
	}
	const s = String(orgNo);
	if (s.length === 10) {
		return s.substring(0, 6) + '-' + s.substring(6, 10);
	}
	return s;
};

export default formatOrgNumber;
